import { RouteObject, createBrowserRouter } from 'react-router';

import ErrorBoundary from '../error-boundary';
import { routes } from './utils';

const router: RouteObject[] = [
  {
    path: '/',
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        // element: <Navigate to="/home" /> // 重定向
      },
      ...routes, // modules 路由
    ],
  },
  // {
  //   path: '*',
  //   element: <Navigate to="/404" /> // 找不到页面
  // }
];

export default createBrowserRouter(router);
